import { Navigate, RouteObject } from 'react-router-dom';

import { Home } from '../modules/home';
import { Roles, SavedRole, RolesLayout } from '../modules/roles';
import {
  Projects,
  SavedProject,
  ProjectsLayout,
  PhaseDetails,
  SavedPhase,
  SavedDirectory,
  SavedDocument,
} from '../modules/projects';
import { SavedUser, Users, UsersLayout } from '../modules/users';
import { ProjectDetails } from '../modules/projects';
import {
  FormsLayout,
  SavedFormTemplate,
  FormTemplates,
} from '../modules/forms';
import { TasksLayout, Tasks } from '../modules/tasks';
import { Main } from '../layouts';
import {
  SinglePhaseProjectDetails,
  MultiplePhaseProjectDetails,
} from '../modules/projects/components';
import { PartnersLayout, SavedPartners } from '../modules/partners';
import { Partners } from '../modules/partners/pages/Partners';

export const authRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Main />,
    children: [
      {
        path: '',
        element: <Home />,
        children: [
          {
            index: true,
            element: <Home />,
          },
          {
            path: 'my-tasks/:tabName',
            element: <Home />,
          },
          {
            path: 'my-team',
            element: <Home />,
          },
          {
            path: 'my-team/:tabName',
            element: <Home />,
          },
        ],
      },
      {
        path: 'analytics',
        element: (
          <>
            <div style={{ width: '80vw', height: '100%' }}>
              <iframe
                src="https://constructive-tech.metabaseapp.com/public/dashboard/8e62deae-bb91-473c-bbbf-da745815f473"
                title="Metabase Dashboard"
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            </div>
          </>
        ),
      },
      {
        path: 'projects',
        element: <ProjectsLayout />,
        children: [
          {
            path: ':type',
            element: <Projects />,
          },
          {
            path: ':type/new-project',
            element: <SavedProject />,
          },
          {
            path: ':type/:projectId',
            element: <SavedProject />,
          },
          {
            path: 'single-phase/:projectId/project-details',
            element: <ProjectDetails />,
            children: [
              {
                index: true,
                element: <SinglePhaseProjectDetails />,
              },
              {
                path: ':tabName',
                element: <SinglePhaseProjectDetails />,
              },
              {
                path: ':tabName/:directoryId',
                element: <SinglePhaseProjectDetails />,
              },
            ],
          },
          {
            path: 'multiple-phase/:projectId/project-details',
            element: <ProjectDetails />,
            children: [
              {
                index: true,
                element: <MultiplePhaseProjectDetails />,
              },
              {
                path: ':tabName',
                element: <MultiplePhaseProjectDetails />,
              },
            ],
          },
          {
            path: ':type/:projectId/project-details/:tabName/:directoryId/new-directory',
            element: <SavedDirectory />,
          },
          {
            path: ':type/:projectId/project-details/:tabName/:directoryId/update-directory',
            element: <SavedDirectory />,
          },
          {
            path: ':type/:projectId/project-details/:tabName/:directoryId/new-document',
            element: <SavedDocument />,
          },
          {
            path: ':type/:projectId/project-details/phases/:phaseId',
            element: <PhaseDetails />,
          },
          {
            path: ':type/:projectId/project-details/phases/new-phase',
            element: <SavedPhase />,
          },
          {
            path: ':type/:projectId/project-details/phases/update/:phaseId',
            element: <SavedPhase />,
          },
          {
            path: ':type/:projectId/project-details/phases/:phaseId/:tabName',
            element: <PhaseDetails />,
          },
          {
            path: ':type/:projectId/project-details/phases/:phaseId/:tabName/:directoryId/new-directory',
            element: <SavedDirectory />,
          },
          {
            path: ':type/:projectId/project-details/phases/:phaseId/:tabName/:directoryId/update-directory',
            element: <SavedDirectory />,
          },
          {
            path: ':type/:projectId/project-details/phases/:phaseId/:tabName/:directoryId/new-document',
            element: <SavedDirectory />,
          },
        ],
      },
      {
        path: 'roles',
        element: <RolesLayout />,
        children: [
          {
            path: ':status',
            element: <Roles />,
          },
          {
            path: ':status/new-role',
            element: <SavedRole />,
          },
          {
            path: ':status/:roleId',
            element: <SavedRole />,
          },
        ],
      },
      {
        path: 'users',
        element: <UsersLayout />,
        children: [
          {
            path: ':status',
            element: <Users />,
          },
          {
            path: ':status/new-user',
            element: <SavedUser />,
          },
          {
            path: ':status/:userId',
            element: <SavedUser />,
          },
        ],
      },
      {
        path: 'companies',
        element: <PartnersLayout />,
        children: [
          {
            index: true,
            element: <Partners />,
          },
          {
            path: 'new-company',
            element: <SavedPartners />,
          },
        ],
      },
      {
        path: 'form-builder',
        element: <FormsLayout />,
        children: [
          {
            index: true,
            element: <FormTemplates />,
          },
          {
            path: 'new-form',
            element: <SavedFormTemplate />,
          },
          {
            path: ':formTemplateId',
            element: <SavedFormTemplate />,
          },
        ],
      },
      {
        path: 'tasks',
        element: <TasksLayout />,
        children: [
          {
            index: true,
            element: <Tasks />,
          },
          {
            path: 'my-tasks/:tabName',
            element: <Tasks />,
          },

          {
            path: 'my-team',
            element: <Tasks />,
          },
          {
            path: 'my-team/:tabName',
            element: <Tasks />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
];
